export const handleSendEmail = (
  subject: string,
  body: string
): void => {
  
  const mailtoUrl = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  window.location.href = mailtoUrl;
};

// Helper function to convert HTML to plain text for mailto
export const htmlToPlainTextMailto = (htmlContent: string): string => {
  return htmlContent
    .replace(/<[^>]*>/g, '') // Remove HTML tags
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\n\s*\n\s*\n/g, '\n\n')
    .replace(/⚠️ IMPORTANT SHOW CAUSE NOTICE/g, '⚠️ IMPORTANT SHOW CAUSE NOTICE\n\n')
    .replace(/IMPORTANT SHOW CAUSE NOTICE/g, 'IMPORTANT SHOW CAUSE NOTICE\n\n')
    .replace(/⚠️ REASONED ORDER PURSUANT TO PRIOR SHOW CAUSE NOTICE/g, '⚠️ REASONED ORDER PURSUANT TO PRIOR SHOW CAUSE NOTICE\n\n')
    .replace(/REASONED ORDER PURSUANT TO PRIOR SHOW CAUSE NOTICE/g, 'REASONED ORDER PURSUANT TO PRIOR SHOW CAUSE NOTICE\n\n')
    .replace(/FRAUD CLASSIFICATION REPORT/g, '⚠️ FRAUD CLASSIFICATION REPORT\n\n')
    .replace(/FRAUD CLASSIFICATION REPORT/g, 'FRAUD CLASSIFICATION REPORT\n\n')
    .replace(/([a-zA-Z])CONFIDENTIALITY NOTICE:/g, '$1\n\n------\n\nCONFIDENTIALITY NOTICE:')
    .trim();
};
